import Vue from 'vue';
import Vuex from 'vuex';
import localStore from 'store';

import auth from '@/store/modules/auth';
import envelopes from '@/store/modules/envelopes/envelopes';
import company from '@/store/modules/company';
import countries from '@/store/modules/countries';
import user from '@/store/modules/users/user';
import branding from '@/store/modules/branding'; // TODO Remove
import emails from '@/store/modules/emails';
import fields from '@/store/modules/fields';
import groups from '@/store/modules/groups';
import templates from '@/store/modules/templates';
import template from '@/store/modules/template';
import users from '@/store/modules/users/users';
import modals from '@/store/modules/modals';
import parties from '@/store/modules/parties';
import ip from '@/store/modules/ip';
import contacts from '@/store/modules/contacts';
import apiKeys from '@/store/modules/apiKeys';
import webhooks from '@/store/modules/webhooks';
import settings from '@/store/modules/settings';
import integrations from '@/store/modules/integrations';
import plan from '@/store/modules/plan';
import plans from '@/store/modules/billing/plans';
import paymentMethods from '@/store/modules/billing/paymentMethods';
import invoices from '@/store/modules/billing/invoices';
import metering from '@/store/modules/billing/metering';
import paygInvoicePreview from '@/store/modules/billing/paygInvoicePreview';
import paygPlans from '@/store/modules/billing/paygPlans';
import plansInvoicePreview from '@/store/modules/billing/plansInvoicePreview';
import featureFlags from '@/store/modules/featureFlags';
import permissions from '@/store/modules/permissions';
import roles from '@/store/modules/roles';
import templatesEnvelopes from '@/store/modules/templatesEnvelopes';
import userMfa from '@/store/modules/mfa';
import bulkSend from '@/store/modules/bulkSend';
import notifications from '@/store/modules/notifications';

Vue.use(Vuex);

const modules = {
  auth,
  envelopes,
  company,
  countries,
  user,
  branding,
  emails,
  fields,
  groups,
  users,
  modals,
  contacts,
  templates,
  template,
  parties,
  ip,
  apiKeys,
  webhooks,
  settings,
  plan,
  plans,
  paymentMethods,
  invoices,
  metering,
  integrations,
  paygInvoicePreview,
  paygPlans,
  plansInvoicePreview,
  featureFlags,
  permissions,
  roles,
  templatesEnvelopes,
  userMfa,
  bulkSend,
  notifications,
};

const store = new Vuex.Store({
  state: {
    initialised: false,
    language: 'en',
  },
  modules,
  actions: {
    async INITIALISE_STORE() {
      const authStateFromLocalStore = localStore.get('auth');

      if (authStateFromLocalStore) {
        // Set the authorization data from the local store
        await store.commit('auth/SET_TOKENS', {
          access_token: authStateFromLocalStore.accessToken,
          refresh_token: authStateFromLocalStore.refreshToken,
          token_type: authStateFromLocalStore.tokenType,
          expires_in: authStateFromLocalStore.expiresIn,
        });

        await store.dispatch('REFRESH_INITIAL_DATA');
      }

      // To keep token validation reactive with the current time we need to the state periodically
      setInterval(() => {
        store.commit('auth/UPDATE_TIME');
      }, 1000);

      store.state.initialised = true;
    },
    async REFRESH_INITIAL_DATA() {
      // These are assumed available once authorised
      await Promise.all([
        store.dispatch('user/GET'),
        store.dispatch('company/GET'),
        store.dispatch('plan/GET'),
        store.dispatch('userMfa/GET'),
      ]);
    },
    async RESET_STATE() {
      await Object.keys(modules).map(async key => store.dispatch(`${key}/RESET_STATE`));
    },
  },
  getters: {
    initialised: state => state.initialised,
  },
});

export default store;
